module.exports = __webpack_public_path__ + "img/file-x-01.284390d0.svg";